module.exports = __webpack_public_path__ + "img/MaidenlessPlateau.e91f0d97.png";